module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm06#ch00_fm06"
    }
  }, [_c('em', [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm07#ch00_fm07"
    }
  }, [_vm._v("Introduction: Perceptions and Realities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm07_part1#ch00_fm07_part1"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART I")]), _vm._v(": European/Native American Contact, 1492–1710")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01"
    }
  }, [_vm._v("1 Sexual Violation in the Conquest of the Americas")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01a"
    }
  }, [_vm._v("Stephanie Wood")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02"
    }
  }, [_vm._v("2 Native American Sexuality in the Eyes of the Beholders 1535–1710")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('em', [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02a"
    }
  }, [_vm._v("Gordon Sayre")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Her Master’s Voice: Gender, Speech, and Gendered Speech in the Narrative of the Captivity of Mary White Rowlandson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Steven Neuwirth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03_part2#ch03_part2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART II")]), _vm._v(": Regulating Sex and Sexuality in Colonial New England")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Regulation of Sex in Seventeenth-Century Massachusetts: The Quarterly Court of Essex County vs. Priscilla Willson and Mr. Samuel Appleton")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Else L. Hambleton")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Sarah Prentice and the Immortalists: Sexuality, Piety, and the Body in Eighteenth-Century New England")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Erik R. Seeman")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05_part3#ch05_part3",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART III")]), _vm._v(": Race, Sex, and Social Control in the Chesapeake and Caribbean in the Eighteenth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 William Byrd’s “Flourish”: The Sexual Cosmos of a Southern Planter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Richard Godbeer")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 The Sexual Life of an Eighteenth-Century Jamaican Slave Overseer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Trevor Burnard")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Sex, Sexuality, and Social Control in the Eighteenth-Century Leeward Islands")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Natalie A. Zacek")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08_part4#ch08_part4",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PART IV")]), _vm._v(": Images of Masculinity, Femininity, and Sexuality in the Eighteenth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Soldiers in Love: Patrolling the Gendered Frontiers of the Early Republic")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Wayne Bodle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 “Imperfect Disclosures”: Cross-Dressing and Containment in Charles Brockden Brown’s "), _c('em', [_vm._v("Ormond")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Heather Smyth")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 “Insidious Murderers of Female Innocence”: Representations of Masculinity in the Seduction Tales of the Late Eighteenth Century")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11#ch11a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Rodney Hessinger")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1a"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 “The Fruit of Unlawful Embraces”: Sexual Transgression and Madness in Early American Sentimental Fiction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc3"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12#ch12a",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Karen A. Weyler")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Contributors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1b"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59474d96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05.vue
// module id = 72
// module chunks = 0